/* eslint-disable */
import { Injectable } from '@angular/core';
import * as ActionCable from '@rails/actioncable';
import { Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class Broadcaster {
  private _eventBus: any;

  constructor() {
    this.init();
  }

  private init() {
    this._eventBus = new Subject();
  }

  public broadcast(key, data) {
    this._eventBus.next({ key, data });
  }

  public on(key) {
    return this._eventBus
      .asObservable()
      .pipe(filter((event) => event['key'] === key))
      .pipe(map((event) => event['data']));
  }

  public off() {
    this.init();
  }
}

@Injectable({
  providedIn: 'root',
})
export class NgxCableService {
  /**
   * NOTE: IF YOU ARE TRYING TO USE ACTION CABLE - YOU ARE IN THE WRONG PLACE - USE action-cable.service.ts
   * This service is taken from https://github.com/isopen/ngx-cable - which is no longer maintained at time of writing this.
   *
   * This has blocked us from upgrading to angular 10, so we've copied it into our application directly to ensure it is maintained.
   * I have little idea of how this works, and until a time that this breaks, I will try not to care - you shouldn't either.
   */

  // Broadcaster is actually being used, though typescript is unable to detect the usage,
  // hence the solution is to suppress it with the following comment.
  // @ts-ignore Unused property error (TS6183)
  constructor(private broadcaster: Broadcaster) {}

  public setCable = function (url: string): void {
    this.cable = ActionCable.createConsumer(url);
  };

  public connect = function (url: string) {
    this.setCable(url);
  };

  public isOpen = function () {
    if (!(this.cable === undefined)) {
      return !this.cable.connection.disconnected;
    }
    return false;
  };

  public create = function (params: { channel: string; room: string }) {
    const _this = this;

    return this.cable.subscriptions.create(params, {
      received(data: any) {
        _this.broadcaster.broadcast(params.channel, data);
      },
    });
  };

  public subscribe = function (params: { channel: string; room: string }) {
    return this.create(params);
  };

  public send = function (data: any, subscriptions?: ActionCable.Subscription[]) {
    if (!this.isOpen()) {
      return false;
    }

    if (subscriptions === null || subscriptions === undefined) {
      this.cable.subscriptions.subscriptions[0].send(data);
    } else if (subscriptions instanceof Array) {
      subscriptions.forEach((subscription) => {
        if (subscription instanceof ActionCable.Subscription) {
          subscription.send(data);
        }
      });
    } else {
      return false;
    }

    return true;
  };

  public perform = function (action: string, data: any, subscriptions?: ActionCable.Subscription[]) {
    if (!this.isOpen()) {
      return false;
    }

    if (subscriptions === null || subscriptions === undefined) {
      this.cable.subscriptions.subscriptions[0].perform(action, data);
    } else if (subscriptions instanceof Array) {
      subscriptions.forEach((subscription) => {
        if (subscription instanceof ActionCable.Subscription) {
          subscription.perform(action, data);
        }
      });
    } else {
      return false;
    }

    return true;
  };

  public unsubscribe = function (subscriptions?: ActionCable.Subscription[]) {
    const _this = this;

    if (subscriptions === null || subscriptions === undefined) {
      this.cable.subscriptions.subscriptions.forEach((subscription) => {
        _this.cable.subscriptions.remove(subscription);
      });
    } else if (subscriptions instanceof Array) {
      subscriptions.forEach((subscription) => {
        if (subscription instanceof ActionCable.Subscription) {
          _this.cable.subscriptions.remove(subscription);
        }
      });
    } else {
      return false;
    }

    return true;
  };

  public getSubscriptions = function () {
    return this.cable.subscriptions.subscriptions;
  };

  public getCountSubscriptions = function () {
    return this.getSubscriptions().length;
  };

  public searchSubcriptions = function (id, field = 'room') {
    const rsub = [];

    this.getSubscriptions().forEach((subscription) => {
      const msg = JSON.parse(subscription.identifier);

      if (id === msg[field]) {
        rsub.push(subscription);
      }
    });

    return rsub;
  };

  public reject = function (subscription: ActionCable.Subscription) {
    if (subscription instanceof ActionCable.Subscription) {
      this.cable.subscriptions.remove(subscription);
    } else {
      return false;
    }

    return true;
  };

  public disconnect = function () {
    if (this.isOpen()) {
      this.cable.disconnect();
    } else {
      return false;
    }
  };
}
